/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../common";
import type {
  UniV3Vault,
  UniV3VaultInterface,
} from "../../contracts/UniV3Vault";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "side",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "FundsDeposited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "side",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bool",
        name: "isEarly",
        type: "bool",
      },
    ],
    name: "FundsWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "timeEnded",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "VaultEnded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "timeStarted",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "VaultStarted",
    type: "event",
  },
  {
    inputs: [],
    name: "adapter",
    outputs: [
      {
        internalType: "contract AdapterBase",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimToken",
    outputs: [
      {
        internalType: "contract VaultBearerToken",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "side",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "deployCapitalData",
        type: "bytes",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "duration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "earnings0",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "earnings1",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "earningsSettled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "endTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeBps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeReceiver",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "fixedBearerToken",
    outputs: [
      {
        internalType: "contract VaultBearerToken",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "fixedSideCapacity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_vaultId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_duration",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_adapter",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_fixedSideCapacity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_variableSideCapacity",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_variableAsset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_feeBps",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_feeReceiver",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "initialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isStarted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "variableAsset",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "variableBearerToken",
    outputs: [
      {
        internalType: "contract VaultBearerToken",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "variableSideCapacity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vaultId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "side",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "removeLiquidityData",
        type: "bytes",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type UniV3VaultConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: UniV3VaultConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class UniV3Vault__factory extends ContractFactory {
  constructor(...args: UniV3VaultConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<UniV3Vault> {
    return super.deploy(overrides || {}) as Promise<UniV3Vault>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): UniV3Vault {
    return super.attach(address) as UniV3Vault;
  }
  override connect(signer: Signer): UniV3Vault__factory {
    return super.connect(signer) as UniV3Vault__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UniV3VaultInterface {
    return new utils.Interface(_abi) as UniV3VaultInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UniV3Vault {
    return new Contract(address, _abi, signerOrProvider) as UniV3Vault;
  }
}
